import { FunctionComponent, PropsWithChildren, useMemo } from 'react';

import { WithOptionsModel } from '../../../../../../../../shared/components/with-options/models/with-options.model';
import { withOptions } from '../../../../../../../../shared/components/with-options/with-options';
import { getModelsByBrand } from '../../../../../../../../shared/thunks/get-models-by-brand/get-models-by-brand.thunk';
import { castTo } from '../../../../../../../shared/utils/cast-to';
import { mapModelEntityToItemLabelModel } from '../../../../../../utils/mapping/mapping.util';
import { FirmwareFilterProps } from '../../../../types/firmware-filter-props.type';

const withModelsOptions = (
  Component: FunctionComponent<FirmwareFilterProps & WithOptionsModel>
): FunctionComponent<FirmwareFilterProps & WithOptionsModel> => {
  return (props: PropsWithChildren<FirmwareFilterProps & WithOptionsModel>) => {
    const selectedBrand = props?.firmwareSelectFilters?.brandId;

    const brandId = selectedBrand
      ? castTo<number>(selectedBrand)
      : props.values.brandId?.id;

    const WrappedComponent = useMemo(
      () =>
        withOptions(Component, {
          dispatchFn: getModelsByBrand,
          mapper: mapModelEntityToItemLabelModel,
          thunkArgs: {
            brandId,
          },
        }),
      [brandId]
    );

    return <WrappedComponent {...props} />;
  };
};

export default withModelsOptions;
